<template>
  <div :class="['question', { 'question--detached': !attached }]">
    <div class="question__title">{{ trailer }}</div>
    <slot name="marker" />
    <a
      v-if="attached"
      class="question__action"
      role="button"
      @click.stop="detachQuestionHandler"
    >
      <b-icon icon="minus-circle" type="is-danger" />
    </a>
    <a
      v-else
      class="question__action"
      role="button"
      @click.stop="attachQuestionHandler"
    >
      <b-icon icon="plus-circle" type="is-primary" />
    </a>
    <b-button
      inverted
      size="is-small"
      type="is-primary"
      @click="editQuestionHandler"
    >
      Edit
    </b-button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import con from '../store/mutationTypes';

export default {
  props: {
    attached: Boolean,
    owner: String,
    question: Object,
    type: {
      type: String,
      default: 'question',
      validator(value) {
        return value === 'question' || value == 'hint';
      }
    }
  },
  computed: {
    definition() {
      // console.log('question', this.question);
      return this.question.flowDefinition;
    },
    trailer() {
      // console.log('definition', this.definition);
      const startPrompt = this.definition && this.definition.prompts.start;
      let trailer = '';
      if (startPrompt && startPrompt.message) {
        trailer = startPrompt.message.substring(0, 15);
        if (startPrompt.message.length > 15) {
          trailer += '...';
        }
      } else {
        trailer = 'Question statement missing!';
      }

      return trailer;
    }
  },
  methods: {
    ...mapActions('questions', ['selectQuestion']),
    editQuestionHandler() {
      this.$store.commit(con.QUESTION_EDITOR_SET_NAMESPACED, {
        questionId: this.question.id,
        questionType: this.type
      });
      this.selectQuestion(this.question.id);
    },
    async attachQuestionHandler() {
      try {
        await this.$store.dispatch(`${this.owner}/attachReference`, {
          path: `questions/${this.question.id}`
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to attach question!',
          type: 'is-danger'
        });
      }
    },
    async detachQuestionHandler() {
      try {
        await this.$store.dispatch(`${this.owner}/detachReference`, {
          path: `questions/${this.question.id}`
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to detach question!',
          type: 'is-danger'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.question {
  display: flex;
  align-items: center;

  &--detached {
    padding: 0.5rem;
    background-color: #ffffff;
    border: 1px solid $border-color;
    border-radius: $border-radius;
    margin-bottom: 0.5rem;
  }

  &__title {
    flex: 1 0 0;
    margin-right: 0.5rem;
  }

  &__action {
    margin-right: 0.5rem;
  }
}
</style>
